
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/residential-and-domestic-excavation-sydney/mini-excavation-sydney",
      function () {
        return require("private-next-pages/services/residential-and-domestic-excavation-sydney/mini-excavation-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/residential-and-domestic-excavation-sydney/mini-excavation-sydney"])
      });
    }
  